import store from '@/store'
import { MessageBox } from 'element-ui'

export function languageExecute() {
  return new Promise((reslove, reject) => {
    if (store.getters['app/language'] !== 'zh') {
      MessageBox.confirm('检测到您的浏览器语言为英文，是否需要跳转至英文站点?', '提示', {
        confirmButtonText: '需要',
        cancelButtonText: '不需要',
        type: 'info'
      }).then(() => {
        location.href = process.env.VUE_APP_EN_URL
        reject()
      }).catch(() => {
        localStorage.setItem('language', 'zh')
        reslove()
      })
    } else {
      reslove()
    }
  })
}
